module.exports = __webpack_public_path__ + "media/images/lb/097-c5257628935265be0c600efd08dcb44c.svg";